<template>
    <cic-popup
        :title="item.accessId ? 'Edit Access Point' : 'New Access Point'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul v-if="!item.accessId">
                <li class="form-label-first">
                    {{ $t('Type') }}
                </li>
                <li>
                    <cic-select
                        id="access_type"
                        :value="item.type"
                        :enabled="editing"
                        :options="
                            [4, 8]
                                .filter((x) => $store.hasRight('EDIT_ACCESS_TYPE_' + x))
                                .map((x) => ({ value: x, label: $t('ACCESS_TYPE_' + x) }))
                        "
                        @input="(val) => $emit('change', 'type', val)"
                    />
                </li>
            </ul>
            <EditEmailAccessPoint
                v-if="item.type === 4"
                :editing="editing"
                :item="item"
                :new-email="newEmail"
                @change="(field, val) => $emit('change', field, val)"
            />
            <EditImAccessPoint
                v-if="item.type === 8"
                :editing="editing"
                :item="item"
                :surveys="surveys"
                @change="(field, val) => $emit('change', field, val)"
            />
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicSelect from '@/components/inputs/CicSelect';
    import EditEmailAccessPoint from './EditEmailAccessPoint';
    import EditImAccessPoint from './EditImAccessPoint';

    export default {
        name: 'EditAccessPoint',
        components: {
            CicPopup,
            CicSelect,
            EditEmailAccessPoint,
            EditImAccessPoint,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            newEmail: {
                type: Boolean,
                default: false,
            },
            surveys: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing:
                    !this.item.accessId ||
                    (this.$store.hasRight('EDIT_ACCESS_TYPE_' + this.item.type) &&
                        (this.item.type !== 8 || this.surveys.length > 0)),
            };
        },
    };
</script>
